export const BASE_URL_TRIAL = '/checkout/trial';
export const BASE_URL_CHECKOUT = '/checkout';
